module.exports = __webpack_public_path__ + "img/img_body_biz_shinhan_card_logo.4b38f256.png";